import styled from "@emotion/native"
import { ReactNode } from "react"
import { LinearGradientWrapper } from "../../ui-components/Onboarding/LinearGradientWrapper"
import { BackArrowV2 } from "../../ui-components"
import { useTheme } from "@emotion/react"
import { SafeAreaView } from "../../ui-components/SafeAreaView"

type OnboardingScreenWrapperProps = {
  children: ReactNode
  stepNumber: number
  /** Machine-driven flows own a one-screen stack, so the arrow can't use goBack. */
  onBack?: () => void
}

export function OnboardingScreenWrapper({
  children,
  stepNumber,
  onBack,
}: OnboardingScreenWrapperProps) {
  const theme = useTheme()
  const firstGradientColorOpacity = stepNumber > 0 ? 0.1 : 0.33
  const isHeadsUpStep = stepNumber === 0

  return (
    <LinearGradientWrapper
      gradientEnd={isHeadsUpStep ? 0.2 : stepNumber > 0 ? 0.25 : 0.67}
      colors={
        isHeadsUpStep
          ? ["#C2D3FB", "#ffffff"]
          : [`rgba(190, 203, 253, ${firstGradientColorOpacity})`, "#ffffff"]
      }
    >
      <ContentContainer>
        <UpperContent>
          <ArrowBackContainer>
            <BackArrowV2
              backgroundColor={theme.v2.components.onboardingWrapper.backArrowContainerColor}
              onPress={onBack}
            />
          </ArrowBackContainer>
          {!!stepNumber && (
            <ProgressIndicatorWrapper>
              {[...Array(6).keys()].map((i) => (
                <ProgressIndicatorStep key={i} isHighlighted={i < stepNumber} />
              ))}
            </ProgressIndicatorWrapper>
          )}
        </UpperContent>
        {children}
      </ContentContainer>
    </LinearGradientWrapper>
  )
}

const ContentContainer = styled(SafeAreaView)`
  flex: 1;
  max-width: 500px;
  width: 100%;
  align-self: center;
`

const ArrowBackContainer = styled.View`
  margin-right: 24px;
`

const UpperContent = styled.View`
  flex-direction: row;
  align-items: center;
  padding: 13px 20px 0 20px;
`

const ProgressIndicatorWrapper = styled.View`
  flex-direction: row;
  gap: 4px;
  flex: 1;
`

const ProgressIndicatorStep = styled.View<{ isHighlighted: boolean }>`
  height: 4px;
  width: 13.5%;
  border-radius: 100px;
  background-color: ${({ theme, isHighlighted }) =>
    isHighlighted
      ? theme.v2.components.onboardingWrapper.progressStepActiveColor
      : theme.v2.components.onboardingWrapper.progressStepColor};
`
